import { SET_VARIABLES, SET_ACTIVE_VIEW } from '../types'


const initialState = {
  openDepartments: false,
  activeView: 'CHAT'
}
export const variablesReducer = (state=initialState, action) => {
  switch (action.type) {
    case SET_VARIABLES:
      return {
        ...state,
       ...action.payload
      }
    case SET_ACTIVE_VIEW:
      return {
        ...state,
        activeView: action.payload
      }
  
    default:
      return state
      
  }
}